'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import PodiumSection from './components/PodiumSection';
import LeaderboardTable from './components/LeaderboardTable';
import { useLanguage } from '@/contexts/LanguageContext';

export default function LeaderboardPage() {
  const { t } = useLanguage();

  return (
    <AppLayout activeRoute="/leaderboard">
      <div className="mb-8">
        <div className="flex items-start justify-between gap-4 mb-6">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs font-semibold uppercase tracking-widest" style={{ color: 'var(--primary)', letterSpacing: '0.08em' }}>
                {t('lb_community_rankings')}
              </span>
            </div>
            <h1 className="text-hero font-extrabold" style={{ color: 'var(--foreground)' }}>
              {t('lb_title')}
            </h1>
            <p className="text-sm mt-2 max-w-lg" style={{ color: 'var(--muted-foreground)' }}>
              {t('lb_desc')}
            </p>
          </div>
          <div
            className="hidden sm:flex items-center gap-2 px-4 py-2.5 rounded-xl flex-shrink-0"
            style={{ background: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.15)' }}
          >
            <span className="pulse-dot" />
            <div>
              <p className="text-xs font-semibold" style={{ color: 'var(--primary)' }}>{t('lb_updated_live')}</p>
              <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>Aug 22, 3:04 PM</p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-glass mb-8 overflow-hidden"
        style={{
          background: 'linear-gradient(180deg, rgba(245,158,11,0.04) 0%, var(--card) 40%)',
          border: '1px solid rgba(245,158,11,0.12)',
        }}
      >
        <div className="px-4 pt-4 pb-0 flex items-center justify-between">
          <h2 className="text-base font-bold" style={{ color: 'var(--foreground)' }}>
            {t('lb_top3')}
          </h2>
          <span className="text-xs font-medium" style={{ color: 'var(--muted-foreground)' }}>
            {t('lb_all_time')}
          </span>
        </div>
        <PodiumSection />
      </div>
      <div className="card-glass p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg font-bold" style={{ color: 'var(--foreground)' }}>
              {t('lb_full_rankings')}
            </h2>
            <p className="text-xs mt-1" style={{ color: 'var(--muted-foreground)' }}>
              {t('lb_all_members')?.replace('{n}', '12')}
            </p>
          </div>
        </div>
        <LeaderboardTable />
      </div>
    </AppLayout>
  );
}